import { get } from 'lodash';
import { useObserver } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { FBAutocompleteAsyncOption } from '../..';
import { translate } from '../../../../common/intl';
import { DocumentRevision } from '../../../../state/ducks/documentRevisions/types';
import { CellTemplateProps } from '../../../components/KendoDataGrid/KendoDataGrid.types';
import OverflowTooltip from '../../../components/OverflowTooltip';
import Colors from '../../../layout/theme/utils/colors';
import FBAutocompleteAsyncStore from '../../FBAutocompleteAsync/FBAutocompleteAsync.store';

const TextCellTemplate: React.FC<CellTemplateProps<{}>> = ({
  field,
  dataItem,
}) => {
  const id = Object.keys(dataItem)[0];
  let defaultValue = get(dataItem, field, '') as string;

  const rowData = useObserver(
    () => {
      const asyncData = FBAutocompleteAsyncStore.data.get(FBAutocompleteAsyncOption.LHR) as Map<string, DocumentRevision>;
      return (asyncData ? Array.from(asyncData.values()).find(item => item.id === id) : {}) as DocumentRevision;
    },
  );
  if(rowData) {
    defaultValue = translate('form.builder.deviation.affected.serial.numbers.lot.display', {
                      docId: rowData.precalc?.lshs_subtitle?.lhr.label,
                      lot: rowData.precalc?.lshs_subtitle?.lot.label,
                      displayRevision: rowData.displayRevision,
                    });
  }

  const rowDataAny = rowData as any;
  const lotDocumentId = rowDataAny?.lotDocumentId;
  const lotDocRevId = rowDataAny?.lotDocRevId;
  const url = (lotDocumentId && lotDocRevId) ? `/document_revision/${lotDocumentId}/version/${lotDocRevId}` : undefined;

  return (
    <OverflowTooltip
      title={defaultValue}
      arrow
      placement="top"
    >
      {url
        ? (
          <Link to={url} target="_blank" style={{ color: Colors.blue }}>
            {defaultValue}
          </Link>
        )
        : defaultValue}
    </OverflowTooltip>
  );
};

export default TextCellTemplate;
